import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const usuariosRestringidos = ["cdconcepcion", "cdita", "cdcaazapa", "cdcde", "cditapua", "cdsantarosa"];
const usuariosCompras = ["mrivas", "cfleitas", "mortiz", "mduarte", "jbogado", "jrbarboza"];
const usuariosEjecucion = ["palegre","mbogarin","msandoval"];
const usuariosLogistica = ["logistica"];
const usuariosPermitidos = ["cgomez"];

const Navbar = ({ handleLogout }) => {
    const [username, setUsername] = useState("");

    const [userInfo, setUserInfo] = useState({
        UserName: "",
        CompanyDB: "",
        WhsCode: ""
    });

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("sapUser"));
        setUsername(user?.UserName || "");
        const storedUser = localStorage.getItem("sapUser");
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUserInfo({
                UserName: parsedUser.UserName,
                CompanyDB: parsedUser.CompanyDB,
                WhsCode: parsedUser.WhsCode
            });
        }
    }, []); // Se ejecuta al montar el componente

    return (
        <>
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <div className="container">
                <Link className="navbar-brand" to="/">
                    <span className="d-inline-flex align-items-center gap-2">
                        <img
                            src={`${process.env.PUBLIC_URL}/LOGO-OSS.png`}
                            alt="OSS LW"
                            style={{ height: 28, width: 28, objectFit: "contain", background: "white", borderRadius: 4, padding: 2 }}
                        />
                        <span>OSS LW</span>
                    </span>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/dashboard">
                                Dashboard
                            </Link>
                        </li>
                        
                        {/* Socios de Negocios */}
                        {(!usuariosRestringidos.includes(username) && !usuariosLogistica.includes(username))&&(
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="clientsDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Clientes
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="clientsDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/clientes/nuevo">
                                        Nuevo Cliente
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/clientes/lista">
                                        Lista de Clientes
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/clientes/cargar-escuelas">
                                        Cargar Lista de Escuelas
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/clientes/cargar-ordenes-servicios">
                                        Cargar Ordenes de Servicios
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Ventas */}
                        {(!usuariosRestringidos.includes(username)
                        && !usuariosLogistica.includes(username))&&(
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="ventasDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Ventas
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="ventasDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/ventas/pedidos/asignacion-logistica">
                                        Asignacion de Logistica
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/factura">
                                        Factura
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/nota-credito">
                                        Nota de Crédito
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/cancelacion-documentos">
                                        Cancelación de Documentos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/cierre-documentos">
                                        Cierre de Documentos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/pedidos/actualizar-lineas">
                                        Actualización de Lineas - Articulos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/actualizacion-precios">
                                        Actualización de Precios
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/remisiones">
                                        Migración de Remisiones
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ventas/remisiones/asignacion-logistica">
                                        Asignacion de Logistica - Remisiones
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Compras */}
                        {(!usuariosRestringidos.includes(username)
                        && !usuariosLogistica.includes(username))&&(
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="ventasDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Compras
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="ventasDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/compras/planificacion">
                                        Planificación de Insumos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/compras/ejecucion/v2">
                                        Ejecución General
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/compras/ejecucion/escuelas">
                                        Ejecución por Escuela
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Bancos */}
                        {((username === "adasilva" || username === "manager")
                        )&& (
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="bancosDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Bancos
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="bancosDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/bancos/asistente-pagos">
                                        Asistente de Pagos
                                    </Link>
                                </li>
                                <li><hr className="dropdown-divider" /></li>
                                <li>
                                    <Link className="dropdown-item" to="/bancos/pagos/sudameris">
                                        Sudameris (TXT)
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/bancos/pagos/atlas">
                                        Atlas (TXT)
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Inventario */}
                        {(username === "adasilva" || username === "manager" || usuariosRestringidos.includes(username)
                        || !usuariosCompras.includes(username) || !usuariosEjecucion.includes(username)
                        || !usuariosLogistica.includes(username))&& (
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="inventarioDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Inventario
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="inventarioDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/inventario/ordenescompra">
                                        Ordenes de Compras Pendientes
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/solicitudestraslados">
                                        Solicitudes de Traslados Pendientes
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/preparacion">
                                        Preparación
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/picking">
                                        Picking
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/devoluciones">
                                        Devoluciones
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/stock">
                                        Stock por Almacén
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/consolidado">
                                        Consolidados
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/consolidado/general">
                                        Consolidados - General
                                    </Link>
                                </li>
                                {(username === "adasilva" || username === "manager" || username === "lpujol" 
                                || usuariosCompras.includes(username) || !usuariosRestringidos.includes(username))&& (
                                <li>
                                    <Link className="dropdown-item" to="/inventario/tablero/ordenescompra">
                                        Tablero de Ordenes de Compras 
                                    </Link>
                                </li>
                                )}
                            </ul>
                        </li> )}
                        {/* Logistica */}
                        {(username === "adasilva" || username === "manager" || usuariosRestringidos.includes(username)
                        || usuariosCompras.includes(username) || usuariosEjecucion.includes(username)
                        || usuariosLogistica.includes(username))&& (
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="logisticaDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Logistica
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="logisticaDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/logistica/asigancionrutas">
                                        Asignación de Rutas
                                    </Link>
                                </li>
                                {/*<li>
                                    <Link className="dropdown-item" to="/logistica/asignaciones">
                                        Asignación unificada (Rutas + Camiones)
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inventario/asignacioncamiones">
                                        Asignacion de Camiones
                                    </Link>
                                </li>*/}
                                <li>
                                    <Link className="dropdown-item" to="/logistica/descargas/remisiones">
                                        Remisiones Electrónicas
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/logistica/choferes">
                                        Mantenimiento de Choferes
                                    </Link>
                                </li>
                                {/*<li>
                                    <Link className="dropdown-item" to="/logistica/ruteo-pendiente">
                                        Ruteo Pendiente
                                    </Link>
                                </li>*/}
                                <li>
                                    <Link className="dropdown-item" to="/logistica/ruteo-camiones">
                                        Asignación de Rutas y Camiones
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                    </ul>
                    
                    {/* Acciones a la derecha */}
                    <div className="d-flex align-items-center ms-auto text-end">
                        <button
                            className="btn btn-danger me-3"
                            onClick={handleLogout}
                        >
                            Cerrar Sesión
                        </button>

                        <div className="text-white small text-end">
                            <div><strong>Usuario:</strong> {userInfo.UserName}</div>
                            <div><strong>BD:</strong> {userInfo.CompanyDB} | <strong>Almacén:</strong> {userInfo.WhsCode}</div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        
        </>
    );
};

export default Navbar;
